module.exports = __webpack_public_path__ + "img/spartan-tenant-improvements-02-xxlarge.28b15f29.jpg";